import type { IconSvgObject } from './types';

const CommentRemove03Icon: IconSvgObject = [
  ["path", { d: "M2 10.5C2 5.5 6 3 12 3C18 3 22 5.5 22 10.5C22 15.5 18 18 12 18V21C12 21 2 18 2 10.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 7.5L12 10.5M12 10.5L15 13.5M12 10.5L15 7.5M12 10.5L9 13.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CommentRemove03Icon;
